/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by bbonet on 1/26/15.
 */

'use strict';
angular.module('prism-ui.components').service('NotificationService', function ($injector, $rootScope, $interval, _) {
    const DEFAULT_NOTIFICATION_OPTIONS = {
        // Max time to keep notification on screen
        delay: undefined,
        allow_dismiss: undefined,
        moreInfoText: 'details...',
        // Function to call when bottom's "Detail" button is clicked
        moreInfoClickHandler: undefined,
        downloadText: undefined,
        // Function to call when "Download" button is clicked
        downloadCallback: undefined,
    };

    var timedNotifications = [];

    const generateNotification = (scope, overrideOptions) => {
        // When message too long & expand button clicked
        scope.longerMessageCallback = this.defaultLongerMessageClickHandler;
        // Parse standardized options
        for (const key in DEFAULT_NOTIFICATION_OPTIONS) {
            if (overrideOptions && key in overrideOptions) {
                scope[key] = overrideOptions[key];
            } else if (DEFAULT_NOTIFICATION_OPTIONS[key] !== undefined) {
                scope[key] = DEFAULT_NOTIFICATION_OPTIONS[key];
            }
        }
        if (scope.detailText === undefined && scope.moreInfoClickHandler) {
            scope.detailText = 'Details';
        }

        const compile = $injector.get('$compile');
        const notificationElement = angular.element(document.createElement('notification-directive'));
        const notification = compile(notificationElement)(scope);

        return { // To allow interfacing with created notification
            close: () => scope.api.close(), // Notice: scope.api not defined until element created later
        };
    };

    // TODO: Refactor all NotificationService calls to use options object
    this.createSuccessNotification = function (message, delay) {
        var options = _.isPlainObject(delay) ? delay : undefined;
        var scope = $rootScope.$new();
        scope.title = 'SUCCESS';
        scope.message = message;
        scope.type = 'success'; //success, info, warning, danger
        /*
         scope.icon = 'fa fa-lg fa-check-circle';
        */
        if (!options) {
            options = {delay: delay || -1};
        }
        return generateNotification(scope, options);
    };

    this.createInfoNotification = function (message, downloadText, downloadCallback) {
        var options = (_.isPlainObject(downloadText)) ? downloadText : undefined;
        var scope = $rootScope.$new();
        scope.title = 'INFO';
        scope.message = message;
        scope.type = 'success'; //success, info, warning, danger
        /*
         scope.icon = 'fa fa-lg fa-info-circle';
        */
        if (!options && downloadText) {
            options = {
                downloadText: downloadText,
                downloadCallback: downloadCallback,
                delay: (downloadText) ? -1 : 5000,
            };
        }
        return generateNotification(scope, options);
    };

    // TODO: When NotificationService.infoNotification options is standardized, delete function.
    //       This func == same as: options.allowDismiss = false
    this.createPersistentInfoNotification = function (message, details, allowDismiss) {
        let hasDetailFunction = typeof(details) === 'function';
        let scope = $rootScope.$new();
        scope.title = 'INFO';
        scope.message = message;
        scope.type = 'success';
        if (hasDetailFunction) {
            scope.moreInfoClickHandler = details;
        } else if (details) {
            scope.detailText = details;
            scope.moreInfoClickHandler = this.defaultMoreInfoClickHandler;
        }
        scope.allow_dismiss = allowDismiss;
        scope.delay = -1;

        return generateNotification(scope);
    };

    this.createPersistentSuccessNotification = function (title, message, details, allowDismiss) {

        let hasDetailFunction = typeof(details) === 'function';
        let scope = $rootScope.$new();
        scope.title = title || 'SUCCESS';
        scope.message = message;
        scope.type = 'success';
        if (hasDetailFunction) {
            scope.moreInfoClickHandler = details;
        } else if (details) {
            scope.detailText = details;
            scope.moreInfoClickHandler = this.defaultMoreInfoClickHandler;
        }
        scope.allow_dismiss = allowDismiss;
        scope.delay = -1;

        return generateNotification(scope);
    };

    this.createPersistentWarningNotification = function (title, message, details, allowDismiss) {
        let hasDetailFunction = typeof(details) === 'function';
        let scope = $rootScope.$new();
        scope.title = title || 'WARNING';
        scope.message = message;
        scope.type = 'warning';
        if (hasDetailFunction) {
            scope.moreInfoClickHandler = details;
        } else if (details) {
            scope.detailText = details;
            scope.moreInfoClickHandler = this.defaultMoreInfoClickHandler;
        }
        scope.allow_dismiss = allowDismiss;
        scope.delay = -1;

        return generateNotification(scope);
    };

    this.createWarningNotification = function (message, moreInfoCallback) {
        var options = (_.isPlainObject(moreInfoCallback)) ? moreInfoCallback : undefined;
        var scope = $rootScope.$new();
        scope.title = 'WARNING';
        scope.message = message;
        scope.type = 'warning'; //success, info, warning, danger
        /*
         scope.icon = 'fa fa-lg fa-exclamation-triangle';
        */
        if (!options) {
            scope.moreInfo = moreInfoCallback;
            options = {moreInfoClickHandler: moreInfoCallback};
        }
        return generateNotification(scope, options);
    };

    this.createFailureNotification = function (message, detailText, allowDismiss, delay) {
        var options = _.isPlainObject(detailText) ? detailText : undefined;
        var scope = $rootScope.$new();
        scope.title = 'ERROR';

        if (_.isString(message)) {
            scope.message = message;
        } else {
            scope.message = message.errorText;
            scope.fileErrorsObject = message.fileErrorsObject;
        }

        scope.type = 'danger'; //success, info, warning, danger
        /*
         scope.icon = 'fa fa-lg fa-times-circle';
        */
        if (!options) {
            scope.detailText = detailText;
            options = {
                moreInfoClickHandler: this.defaultMoreInfoClickHandler,
                allow_dismiss: allowDismiss,
                delay: delay || -1,
            };
        }
        return generateNotification(scope, options);
    };

    this.createTimedInfoNotification = function (message, intervalTime) {
        var timed = $interval(this.createInfoNotification, intervalTime, 1, true, message);
        timedNotifications.push(timed);
    };

    this.defaultLongerMessageClickHandler = function (messageText, message) {
        let ModalService = $injector.get('ModalService');
        ModalService.showMessageModal({
            messageText: messageText,
            pullCancelLeft: true,
            title: 'Error Message',
            windowClass: 'wide-message-modal'
        });
    };

    this.defaultMoreInfoClickHandler = function (detailText, message) {
        let messageOptions = {
            messageText: detailText,
            pullCancelLeft: true,
            title: 'Message Detail',
            windowClass: 'wide-message-modal'
        };

        if (message && !_.isString(message)) {
            messageOptions.messageText = [detailText];
            _.forEach(message, (messageObject) => {
                if (_.get(messageObject, 'failures')) {
                    _.forEach(messageObject.failures, (failure) => {
                        let failureMessage = `${failure.source}: ${failure.description}`;
                        messageOptions.messageText.push(failureMessage);
                    });
                } else {
                    messageOptions.messageText.push(messageObject);
                }
            });
        }

        let ModalService = $injector.get('ModalService');
        ModalService.showMessageModal(messageOptions);
    };

    this.clearTimedNotifications = function () {
        angular.forEach(timedNotifications, function (timed) {
            $interval.cancel(timed);
        });
    };
});
